<template>
  <v-group :config="{ ...groupConfig }">
    <template v-for="l in layers">
      <template v-if="isVisible(l)">
        <group-layer
          v-if="l.type === 'Group'"
          :layer="l"
          :key="l.id"
          :artworkID="artworkID"
          :offset="offset"
          :scale="scale"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
        <image-layer
          v-if="l.type === 'Image'"
          :layer="l"
          :key="l.id"
          :artworkID="artworkID"
          :offset="offset"
          :scale="scale"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
        <text-layer
          v-if="l.type === 'Text'"
          :layer="l"
          :key="l.id"
          :artworkID="artworkID"
          :scale="scale"
          :offset="offset"
          :parentRatio="parentRatio"
          :rotation="rotation"
        />
      </template>
    </template>
  </v-group>
</template>
<script>
import Image from './Image'
import Text from './Text'
import { get } from 'lodash'
import { mapGetters } from 'vuex'
import { checkCondition, isMoonColorVisible } from '@/helper/helper'

export default {
  name: 'group-layer',
  components: { 'image-layer': Image, 'text-layer': Text },
  props: {
    layer: {
      type: Object,
      default() {
        return null
      }
    },
    offset: {
      type: Object
    },
    scale: {
      type: Number,
      default() {
        return 1
      }
    },
    artworkID: {
      type: String,
      required: true
    },
    parentRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    rotation: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {
    ...mapGetters(['personalized', 'artworks']),
    groupConfig() {
      var config = {
        ...this.layer
      }
      var scaleProps = ['x', 'y', 'width', 'height']
      scaleProps.forEach(key => {
        if (config[key]) {
          config[key] = config[key] * this.scale
        }
      })
      return config
    },
    layers() {
      return get(this.layer, 'layers', [])
    },
    artwork() {
      const { artworks, artworkID } = this
      return artworks.find(art => art.id === artworkID)
    },
    template() {
      const { artwork, personalized } = this
      return get(personalized, `${artwork.id}.template`, 0)
    },
    templateLayers() {
      const { template, artwork } = this
      return artwork.templates[template].layers
    }
  },
  methods: {
    checkCondition(layer) {
      const { templateLayers, personalized, artworkID } = this
      const data = get(personalized, artworkID)
      return checkCondition(layer, data, templateLayers)
    },
    isVisible(layer) {
      if (
        get(layer, 'personalized.enable', false) !== true &&
        layer.excludeMockup === true
      ) {
        return false
      }
      const { templateLayers, personalized, artworkID } = this
      const data = get(personalized, artworkID)
      return this.checkCondition(layer) && isMoonColorVisible(layer, templateLayers, data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Artwork/Group.vue